<template>
  <div class="row bgc-wrapper margin-top-42">
    <div class="col-lg-12 col-md-12 col-sm-12 traveller-heading accordion-toggle">
      <div class="row">
        <div>
          <button
            id = "change_in_cpa"
            type="button"
            class="expand-form-button"
            data-toggle="collapse"
            aria-label="Expand Journey Details"
            data-target="#ChangeInCpa"
          >
            <img alt="Toggle Policy Details" src="@/assets/images/arr-up.png" />
          </button>
        </div>
        <h3>Change In CPA</h3>
      </div>
    </div>
    <div class="collapse show col-lg-12 col-md-12 col-sm-12 bgc-form-box" id="ChangeInCpa">
      <div class="risk row">
        <!-- CPA Cover Applicability* starts-->
          <div class=" col-lg-3 col-md-3 col-sm-6" v-if="changeInCPAData.cpaApplicability.visibility">
              <div class="row form-group">
                  <float-label label="CPA Cover Applicability*" :fixed="isFloat(changeInCPAData.cpaApplicability.value)">
                      <select
                      class="form-control"
                      placeholder="CPA Cover Applicability*"
                      v-model="changeInCPAData.cpaApplicability.value"
                      v-evolvews="changeInCPAData.cpaApplicability"
                      :class="{ 'bgc-error-field': changeInCPAData.cpaApplicability.errorText!=='' }"
                      disabled
                      >
                        <option disabled selected value>CPA Cover Applicability*</option>
                        <option disabled :value='null' v-if='changeInCPAData.cpaApplicability.value == null'>CPA Cover Applicability*</option>
                        <option disabled value=''  v-if='changeInCPAData.cpaApplicability.value == ""'>CPA Cover Applicability*</option>
                        <option v-for="cpaApplicability in domainValues.cpaApplicabilityResponse.cpaApplicabilityList" :key="cpaApplicability.code" :value="cpaApplicability.code">{{cpaApplicability.name}}</option>
                      </select>
                  </float-label>
                  <span
                      class="error-text"
                      v-if="changeInCPAData.cpaApplicability.errorText !== ''"
                      >{{ changeInCPAData.cpaApplicability.errorText }}</span>
              </div>
          </div>
          <!-- CPA Cover Applicability* ends-->
          <!--CPA Exemption Reason* starts-->
        <div class="col-lg-3 col-md-3 col-sm-6" v-if="changeInCPAData.exemptionReason.visibility">
          <div class="row form-group">
            <float-label
              label="CPA Exemption Reason*"
              :fixed="isFloat(changeInCPAData.exemptionReason.value)">
              <select
                class="form-control"
                placeholder="CPA Exemption Reason*"
                :class="{'bgc-error-field':changeInCPAData.exemptionReason.errorText !== '' }"
                v-model="changeInCPAData.exemptionReason.value"
                :disabled="getSavedQuoteData.riskDetails.customerType == 'O'"
                @change="resetData()+checkExemption()"
                v-evolvews="changeInCPAData.exemptionReason">
                <option disabled :value='null' v-if='changeInCPAData.exemptionReason.value == null'>CPA Exemption Reason*</option>
                <option disabled value=''  v-if='changeInCPAData.exemptionReason.value == ""'>CPA Exemption Reason*</option>
                <option v-for="exemptionReason in state.exemptionReasonsList" :key="exemptionReason.code" :value="exemptionReason.code">{{exemptionReason.name}}</option>
              </select>
            </float-label>
            <span
              class="error-text"
              v-if="changeInCPAData.exemptionReason.errorText !== ''"
              >{{ changeInCPAData.exemptionReason.errorText }}</span>
          </div>
        </div>
        <!--CPA Exemption Reason* ends-->
        <!-- PA Insurer Name starts-->
        <div class="col-lg-3 col-md-3 col-sm-6" v-if="changeInCPAData.paInsurerName.visibility && changeInCPAData.exemptionReason.value == 'AHPACO15L'">
          <div class="row form-group">
          <float-label :fixed="isFloat(changeInCPAData.paInsurerName.value)" label="PA Insurer Name*">
            <select
              class="form-control"
              placeholder="PA Insurer Name*"
              v-model="changeInCPAData.paInsurerName.value"
              v-evolvews="changeInCPAData.paInsurerName"
              :class="{'bgc-error-field':changeInCPAData.paInsurerName.errorText !== '' }"
            >
              <!-- <option disabled selected value>Insurer Name</option> -->
              <option disabled :value='null' v-if='changeInCPAData.paInsurerName.value == null'>PA Insurer Name*</option>
              <option disabled value=''  v-if='changeInCPAData.paInsurerName.value == ""'>PA Insurer Name*</option>
              <option v-for="insurer in domainValues.initPreviousPolicyDetails.insuranceCompanies" :key="insurer.code" :value="insurer.code">{{insurer.name}}</option>
            </select>
          </float-label>
          <span
            class="error-text"
            v-if="changeInCPAData.paInsurerName.errorText!==''"
          >{{changeInCPAData.paInsurerName.errorText}}</span>
          </div>
        </div>
        <!-- PA Insurer Name end-->
        <!-- PA Policy Number starts-->
        <div class="col-lg-3 col-md-3 col-sm-6" v-if="changeInCPAData.paPolicyNumber.visibility && changeInCPAData.exemptionReason.value == 'AHPACO15L'">
          <div class="row form-group">
          <float-label :fixed="isFloat(changeInCPAData.paPolicyNumber.value)" label="PA Policy Number*">
            <input
              type="text"
              class="form-control"
              placeholder="PA Policy Number*"
              :class="{'bgc-error-field':changeInCPAData.paPolicyNumber.errorText !== '' }"
              maxlength="30"
              v-on:keydown="onlyNumber"
              v-model="changeInCPAData.paPolicyNumber.value"
              v-evolvews="changeInCPAData.paPolicyNumber"
            />
          </float-label>
          <span
            class="error-text"
            v-if="changeInCPAData.paPolicyNumber.errorText!==''"
          >{{changeInCPAData.paPolicyNumber.errorText}}</span>
          </div>
        </div>
        <!-- PA Policy Number end-->
      </div>
      <div class="row">
        <!-- PA Policy Inception Date starts-->
        <div class="col-lg-3 col-md-3 col-sm-6" v-if="changeInCPAData.paPolicyInceptionDate.visibility && changeInCPAData.exemptionReason.value == 'AHPACO15L'">
          <div class="row form-group">
          <float-label
            label="PA Policy Inception Date*"
            :fixed="isFloat(changeInCPAData.paPolicyInceptionDate.value)"
          >
            <datepicker
              format="dd/MM/yyyy"
              :typeable="true"
              @datePickerBlurred="checkError(changeInCPAData.paPolicyInceptionDate,false)"
              @input="checkError(changeInCPAData.paPolicyInceptionDate,false)"
              :input-class="isInputError(changeInCPAData.paPolicyInceptionDate.errorText)"
              placeholder="PA Policy Inception Date*"
              v-model="changeInCPAData.paPolicyInceptionDate.value" 
              :disabledDates="disableInceptionDate" 
            ></datepicker>
          </float-label>
          <span
            class="error-text"
            v-if="changeInCPAData.paPolicyInceptionDate.errorText!==''"
          >{{changeInCPAData.paPolicyInceptionDate.errorText}}</span>
          </div>
        </div>
        <!-- PA Policy Inception Date end-->
        <!-- PA Policy Expiry Date starts-->
        <div class="col-lg-3 col-md-3 col-sm-6" v-if="changeInCPAData.paPolicyExpiryDate.visibility && changeInCPAData.exemptionReason.value == 'AHPACO15L'">
          <div class="row form-group">
          <float-label
            label="PA Policy Expiry Date*"
            :fixed="isFloat(changeInCPAData.paPolicyExpiryDate.value)"
          >
            <datepicker
              format="dd/MM/yyyy"
              :typeable="true"
              @datePickerBlurred="checkError(changeInCPAData.paPolicyExpiryDate,false)"
              @input="checkError(changeInCPAData.paPolicyExpiryDate,false)"
              :input-class="isInputError(changeInCPAData.paPolicyExpiryDate.errorText)"
              :disabledDates="disableExpiryDate" 
              placeholder="PA Policy Expiry Date*"
              v-model="changeInCPAData.paPolicyExpiryDate.value"
            ></datepicker>
          </float-label>
          <span
            class="error-text"
            v-if="changeInCPAData.paPolicyExpiryDate.errorText!==''"
          >{{changeInCPAData.paPolicyExpiryDate.errorText}}</span>
          </div>
        </div>
        <!-- PA Policy Expiry Date end-->
      </div>
    </div>
  </div>
</template>

<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import functions from "@/../../masters/functions.js";
import Datepicker from "vuejs-datepicker";
// import base from "@/../../masters/base.js";
import moment from "moment";
import { reactive, onUpdated, onMounted, computed} from "@vue/composition-api";
export default {
  name: "ChangeInCPA",
  props: ["changeInCPAData", "domainValues",'isCpaMandatory','getSavedQuoteData'],
  components: {
    FloatLabel,
    Datepicker
  },
  setup(props, context) {
    let state = reactive({
      exemptionReasonsList : []
    });
    //onMounted
    onMounted(()=>{
      state.exemptionReasonsList = JSON.parse(JSON.stringify(props.domainValues.initMotorDomainLists.exemptionReasons));
      if(props.getSavedQuoteData.riskDetails.customerType == 'O'){
        props.changeInCPAData.exemptionReason.value = 'I'
      }
      else{
        state.exemptionReasonsList = props.domainValues.initMotorDomainLists.exemptionReasons.filter(exemptionReason=>{
          return (exemptionReason.code != 'I'); //  && exemptionReason.code != 'O'
        });
      }
      checkExemption();
      if(props.isCpaMandatory){
        state.exemptionReasonsList =  state.exemptionReasonsList.filter(exemptionReason=>{
          return exemptionReason.code != 'O';
        });
      }
    });
    const checkError = functions.checkError;
    const isInputError = functions.isInputError;
    const isFloat = functions.isFloat;
    const onlyCharSpace =  functions.onlyCharSpace;
    const onlyNumber =  functions.onlyNumber;
    function resetData(){
      props.changeInCPAData.paPolicyNumber.errorText = '';
      props.changeInCPAData.paInsurerName.errorText = '';
      props.changeInCPAData.paPolicyInceptionDate.errorText = '';
      props.changeInCPAData.paPolicyExpiryDate.errorText = '';
      props.changeInCPAData.paPolicyNumber.value = props.changeInCPAData.paPolicyNumber.oldValue;
      props.changeInCPAData.paInsurerName.value = props.changeInCPAData.paInsurerName.oldValue;
      props.changeInCPAData.paPolicyInceptionDate.value = props.changeInCPAData.paPolicyInceptionDate.oldValue;
      props.changeInCPAData.paPolicyExpiryDate.value = props.changeInCPAData.paPolicyExpiryDate.oldValue;
    }
    function checkExemption(){
      if(props.changeInCPAData.cpaApplicability.value == 'E' && props.changeInCPAData.exemptionReason.value == 'AHPACO15L'){
        context.root.$set(props.changeInCPAData.paPolicyNumber,'stepsMandatory', true);
        context.root.$set(props.changeInCPAData.paInsurerName,'stepsMandatory', true);
        context.root.$set(props.changeInCPAData.paPolicyInceptionDate,'stepsMandatory', true);
        context.root.$set(props.changeInCPAData.paPolicyExpiryDate,'stepsMandatory', true);
        delete props.changeInCPAData.paPolicyNumber.skip;
        delete props.changeInCPAData.paInsurerName.skip;
        delete props.changeInCPAData.paPolicyInceptionDate.skip;
        delete props.changeInCPAData.paPolicyExpiryDate.skip;
      }
      else{
        context.root.$set(props.changeInCPAData.paPolicyNumber,'skip', true);
        context.root.$set(props.changeInCPAData.paInsurerName,'skip', true);
        context.root.$set(props.changeInCPAData.paPolicyInceptionDate,'skip', true);
        context.root.$set(props.changeInCPAData.paPolicyExpiryDate,'skip', true);
        delete props.changeInCPAData.paPolicyNumber.stepsMandatory;
        delete props.changeInCPAData.paInsurerName.stepsMandatory;
        delete props.changeInCPAData.paPolicyInceptionDate.stepsMandatory;
        delete props.changeInCPAData.paPolicyExpiryDate.stepsMandatory;
      }
    }
    onUpdated(()=>{
      // let progressStep = 0;
      // Object.values(props.changeInCPAData).forEach(obj => {
      //   if(obj.stepsMandatory){
      //     if(obj.value && !obj.errorText){
      //       progressStep++;
      //     }
      //   }
      // })
      context.parent.calculateSteps();
      if(props.getSavedQuoteData.riskDetails.cpaApplicability == 'E'){
        context.parent.enableCalculatePremiumBtn('changeInCPA');
      }
    })
    const disableInceptionDate= computed(()=>{
      return {
        from: moment(new Date()).add(1,'d').startOf('day').toDate()
      }
    })
    const disableExpiryDate= computed(()=>{
      return {
        to: moment(new Date()).subtract(1,'d').toDate()
      }
    })
    return {
      state,
      isFloat,
      checkError,
      isInputError,
      onlyCharSpace,
      onlyNumber,
      disableExpiryDate,
      disableInceptionDate,
      resetData,
      checkExemption
    };
  },
   directives: {
    evolvews: functions.evolvews
  }
};
</script>
